import { render, staticRenderFns } from "./CargoTable.vue?vue&type=template&id=1d80e412&"
import script from "./CargoTable.vue?vue&type=script&lang=js&"
export * from "./CargoTable.vue?vue&type=script&lang=js&"
import style0 from "./CargoTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports